module.exports = {
      id: "cad-usage",
      viewBox: "0 0 24 16",
      url: __webpack_public_path__ + "sprite-dbc6d5.smartcharts.svg#cad-usage",
      toString: function () {
        return this.url;
      }
    }